(function (root, factory) {
	if (typeof module === 'object' && module.exports) {
		module.exports = factory();
	} else {
		root.GiftTiersLogic = factory();
	}
})(typeof self !== 'undefined' ? self : this, function () {

	function isGiftLine(item) {
		return !!(item.properties && item.properties._gift_tier);
	}

	function computeQualifyingCents(items, giftVariantIds, excludedProductIds) {
		const giftIds = new Set(giftVariantIds);
		const excluded = new Set(excludedProductIds);
		let cents = 0;
		for (const item of items) {
			if (isGiftLine(item) && giftIds.has(item.variant_id)) continue;
			if (excluded.has(item.product_id)) continue;
			cents += item.line_price;
		}
		return cents;
	}

	function resolveMetTiers(qualifyingCents, tiers) {
		return tiers.filter(function (t) { return t.threshold <= qualifyingCents; });
	}

	function diffGiftLines(items, tiers, qualifyingCents) {
		const met = resolveMetTiers(qualifyingCents, tiers);
		const metByVariant = new Map(met.map(function (t) { return [t.giftVariantId, t]; }));

		// Gift lines currently in the cart, keyed by variant.
		const presentGiftItems = items.filter(isGiftLine);
		const presentByVariant = new Map(presentGiftItems.map(function (i) { return [i.variant_id, i]; }));

		const toAdd = [];
		for (const tier of met) {
			if (!presentByVariant.has(tier.giftVariantId)) {
				toAdd.push({ variantId: tier.giftVariantId, threshold: tier.threshold });
			}
		}

		const toRemove = [];
		for (const item of presentGiftItems) {
			if (!metByVariant.has(item.variant_id)) {
				toRemove.push({ key: item.key });
			}
		}

		return { toAdd: toAdd, toRemove: toRemove };
	}

	// The next unmet milestone the shopper is progressing toward. Free shipping is the
	// first milestone; gift tiers follow. Returns null once everything is unlocked.
	function resolveNextMilestone(qualifyingCents, tiers, freeShippingThreshold) {
		const milestones = [];
		if (freeShippingThreshold > 0) {
			milestones.push({ type: "shipping", threshold: freeShippingThreshold, tier: null });
		}
		for (const t of tiers) {
			milestones.push({ type: "gift", threshold: t.threshold, tier: t });
		}
		const next = milestones
			.filter(function (m) { return m.threshold > qualifyingCents; })
			.sort(function (a, b) { return a.threshold - b.threshold; })[0];
		if (!next) return null;
		return {
			type: next.type,
			threshold: next.threshold,
			remaining: next.threshold - qualifyingCents,
			tier: next.tier
		};
	}

	return {
		isGiftLine: isGiftLine,
		computeQualifyingCents: computeQualifyingCents,
		resolveMetTiers: resolveMetTiers,
		diffGiftLines: diffGiftLines,
		resolveNextMilestone: resolveNextMilestone
	};
});
